/** Coalesce HTTP/WS sale invalidations, retaining failed refreshes for the next poll. */
export class StallSaleSaveSync {
  private wanted = 0;
  private applied = 0;
  private pending: Promise<void> | null = null;

  constructor(private readonly refresh: () => Promise<void>) {}

  invalidate(): void { this.wanted++; }

  flush(): Promise<void> {
    if (this.pending) return this.pending;
    if (this.applied === this.wanted) return Promise.resolve();
    const run = async (): Promise<void> => {
      while (this.applied < this.wanted) {
        const version = this.wanted;
        await this.refresh();
        this.applied = version;
      }
    };
    this.pending = run().finally(() => { this.pending = null; });
    return this.pending;
  }
}
